import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { COLORS } from "@gc-npm/utils.enums.colors";
import sendGaEvent from "@gc-npm/utils.metrics.send-ga-component-event";
import { actions as modalActions } from "@gc-npm/reducers.modals-reducer";
import { actions as clientActions } from "@/reducers/client";
import IconGlyph from "@gc-npm/components.icon-glyph";
import Spinner, { LOADING_STATE } from "@gc-npm/components.spin";
import Price, {
  PRICE_DECORATION,
  PRICE_FONT_WEIGHT,
  PRICE_SIZE,
} from "@gc-npm/components.price";
import TextInfo, {
  TEXT_KIND,
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_FONT_WEIGHT,
} from "@gc-npm/components.text";
import { actions as uiActions } from "@/reducers/ui";
import Form from "@/components/FormSkeleton";
import { API_STATUS, PUSSUB_STATES_DICTIONARY } from "@/utils/constants";
import RetenModalForm from "../RetenModal/RetenModalForm";

const COMPONENT_NAME = "PreventionModal";
const HTML_TAG_REGEX = /<\/?[a-z][^>]*>/i;

// Con HTML el texto va entero (partirlo por lineas rompe las etiquetas).
const getAdviceParagraphs = (text) => (
  HTML_TAG_REGEX.test(text) ? [text] : text.split('\n').filter(Boolean)
);

const PreventionModal = ({ data, onClick, componentProduct }) => {
  const {
    productName,
    promotions,
    headerTitle,
    title,
    downgrades,
    r2r,
    advice,
    acceptText,
    cancelText,
  } = data || {};
  const dispatch = useDispatch();
  const bundleModules = useSelector((state) => state.client.bundleModules);
  const pubSubMessage = `Preven:${data?.productName}_client:${bundleModules && [...bundleModules].sort((a, b) => a - b).join("-")}`;
  const [activePromo, setActivePromo] = useState(0);
  const [showR2RInfo, setShowR2RInfo] = useState(true);

  const client = useSelector((state) => state.client);

  const r2rList =
    showR2RInfo && client && client.status === API_STATUS.OK && client.r2r;
  const r2rButtonText =
    showR2RInfo && client.status === API_STATUS.KO
      ? r2r?.buttonKoText
      : r2r?.buttonText;

  // si da 401 que no aparezca la opcion de ver cuotas de R2R
  // let r2rList = null;
  // let r2rButtonText = null;
  // if (client?.status !== 401) {
  //   r2rList = showR2RInfo && client && client.status === API_STATUS.OK && client.r2r;
  //   r2rButtonText = (showR2RInfo && client.status === API_STATUS.KO)
  //     ? r2r?.buttonKoText
  //     : r2r?.buttonText;
  // }
  const {
    promoUrlLegal,
    legalLinkText,
    legalText,
    acceptText: promoAcceptText,
    cancelText: promoCancelText,
    isHired,
    keepText,
    keepStatus,
  } = promotions?.[activePromo] || {};
 const onCloseModal = () => {
    dispatch(
      modalActions.addModal({
        id: '',
      }),
    );
  };
  // const acceptBtnLabel = keepText || promoAcceptText || acceptText;
  // const cancelBtnLabel = promoCancelText || cancelText;

  const acceptBtnLabel = acceptText;
  const cancelBtnLabel = cancelText;
  const havePromotion = !isHired && promotions?.[activePromo];
  // const submitText = !promotions?.[activePromo] ? cancelBtnLabel : acceptBtnLabel;
  // const dismissText = !promotions?.[activePromo] ? acceptBtnLabel : cancelBtnLabel;
  const submitText = cancelBtnLabel;
  const dismissText = acceptBtnLabel;
  const taggingInfo = {
    componentName: COMPONENT_NAME,
    componentContent: "",
    componentProduct,
    componentVariation: "all",
  };

  useEffect(() => {
    if (r2r || downgrades) {
      sendGaEvent({
        ...taggingInfo,
        eventType: "print-success",
      });
      dispatch(
        uiActions.sendPubSub({
          state: PUSSUB_STATES_DICTIONARY.PURCHASE.PREVENTION.SHOW,
          stateMessage: pubSubMessage,
        })
      );
    }
  }, []);

  useEffect(() => {
    if (showR2RInfo && client?.status === 401) {
      dispatch(uiActions.navigate2Login());
    }
  }, [showR2RInfo, client]);

  const retryCountRef = useRef(0);
  const retryTimerRef = useRef(null);

  useEffect(() => {
    const bundleId = r2r?.bundleId;

    if (client?.status === API_STATUS.LOADING) {
      return;
    }

    if (client?.status === 401) {
      return;
    }

    if (!bundleId) {
      return;
    }

    if (client?.status === API_STATUS.OK && client?.r2r && data?.r2r) {
      retryCountRef.current = 0;
      return;
    }

    if (retryCountRef.current >= 3) {
      return;
    }

    if (retryTimerRef.current) {
      clearTimeout(retryTimerRef.current);
    }

    const delay = retryCountRef.current === 0 ? 0 : 60000;
    retryTimerRef.current = setTimeout(() => {
      retryCountRef.current += 1;
      dispatch(clientActions.getMyR2R(bundleId));
    }, delay);

    return () => {
      if (retryTimerRef.current) {
        clearTimeout(retryTimerRef.current);
      }
    };
  });

  const onClickHandler = () => {
    // siguiente prevention/purchaseProcess
    if (onClick) {
      dispatch(
        uiActions.sendPubSub({
          state: PUSSUB_STATES_DICTIONARY.PURCHASE.PREVENTION.REJECTED,
          stateMessage: pubSubMessage,
        })
      );
      onClick();
    }
  };

  // const onClickR2RHandler = () => {
  //   if (client?.status === API_STATUS.KO) {
  //     dispatch(clientActions.getMyR2R(r2r?.bundleId));
  //   }
  //   setShowR2RInfo(true);
  // };

  const onCancel = () => {
    // se arrepiente y no continua con el cambio
    dispatch(
      uiActions.sendPubSub({
        state: PUSSUB_STATES_DICTIONARY.PURCHASE.PREVENTION.ACEPTED,
        stateMessage: pubSubMessage,
      })
    );
    onCloseModal();
  };

  if (!r2r && !downgrades) {
    // siguiente prevention
    onClickHandler();
    return null;
  }

  // const onSubmit = (isAccept) => {
  //   if (promotions && promotions[activePromo]) {
  //     // si hay promocion
  //     promotions[activePromo].accept = isAccept;
  //     if (isAccept && promotions[activePromo].isHired) {
  //       // pantalla de confirmacion de que le mantenemos la promo
  //       const status = CONFIRMATION_STATUS.OK;
  //       dispatch(
  //         uiActions.setConfirmation({
  //           type: CONFIRMATION_TYPES.KEEP,
  //           status,
  //           info: keepStatus && keepStatus[status],
  //         }),
  //       );
  //     } else if (promotions[activePromo + 1]) {
  //       setActivePromo(activePromo + 1);
  //     } else if (promotions.some((promo) => promo.accept)) {
  //       // filtrar para solo mandar las aceptadas
  //       const acceptedPromotions = promotions.filter((promo) => promo.accept).map(({ id }) => id);
  //       dispatch(uiActions.sendRetentionPromo({
  //         promotions: acceptedPromotions,
  //       }));
  //       dispatch(
  //         modalActions.addModal({
  //           id: '',
  //         }),
  //       );
  //     } else {
  //       onClickHandler();
  //     }
  //   } else if (isAccept) {
  //     // si no hay promocion y acepta
  //     onCancel();
  //   } else {
  //     // si no hay promocion y NO acepta
  //     onClickHandler();
  //   }
  // }
  const onSubmit = (isAccept) => {
    if (isAccept) {
      //acepta
      onCancel();
    } else {
      // NO acepta
      onClickHandler();
    }
  };
  const downgradesTitle = downgrades?.title;
  const captitalizedDowngradesTitle =
    downgradesTitle.charAt(0).toUpperCase() + downgradesTitle.slice(1);

  return (
    <div className="PreventionModal">
      {console.log("data prevention modal 2", r2r)}
      <div className="PreventionModal_Header">
        {headerTitle && (
          <TextInfo
            text={headerTitle}
            kind={TEXT_KIND.PARAGRAPH}
            color={TEXT_COLOR.MOVISTAR_BLACK}
            size={TEXT_SIZE.T7}
          />
        )}
        {/* <div className="cerrar">
          <CustomLink
            taggingInfo={{ ...taggingInfo, componentContent: 'Cerrar' }}
            onClick={onCancel}
          >
            <IconGlyph
              id="Cerrar"
              height={14}
              width={14}
              color={TEXT_COLOR.MOVISTAR_BLUE}
            />
          </CustomLink>
        </div> */}
      </div>
      <hr />
      <div className="PreventionModal_content">
        {title && (
          <TextInfo
            text={title}
            kind={TEXT_KIND.PARAGRAPH}
            color={TEXT_COLOR.GREY6}
            size={TEXT_SIZE.T4}
            fontType={TEXT_FONT_WEIGHT.BOLD}
          />
        )}
        {advice && (
          <div className="PreventionModal_content_advice">
            {advice.icon && (
              <IconGlyph id={advice.icon} height={20} width={20} />
            )}
            <div className="PreventionModal_content_advice_text">
              {advice.text && (
                getAdviceParagraphs(advice.text)
                  .map((text, index) => (
                    <TextInfo
                      key={`advice-${index}`}
                      text={text.trim()}
                      kind={TEXT_KIND.PARAGRAPH}
                      color={TEXT_COLOR.GREY6}
                      size={TEXT_SIZE.CAPTION3}
                    />
                  ))
                )}
              </div>
          </div>
        )}
        {r2r && (
          <div className="PreventionModal_content_r2r">
            <div className="PreventionModal_content_r2r-info">
              {r2r.icon && (
                <IconGlyph
                  id={r2r.icon}
                  height={20}
                  width={20}
                  color={TEXT_COLOR.RED_DARK}
                />
              )}
              <div className="PreventionModal_content_r2r-info__text">
                {r2r.text && (
                  <TextInfo
                    text={r2r.text}
                    kind={TEXT_KIND.PARAGRAPH}
                    color={TEXT_COLOR.GREY6}
                    size={TEXT_SIZE.CAPTION3}
                  />
                )}
                {!r2rList && (
                  <div className="PreventionModal_content_r2r-info__text--action">
                    {showR2RInfo &&
                      client.status === API_STATUS.KO &&
                      r2r.koText && (
                        <TextInfo
                          text={r2r.koText}
                          kind={TEXT_KIND.SPAN}
                          color={TEXT_COLOR.GREY5}
                          size={TEXT_SIZE.CAPTION3}
                          fontType={TEXT_FONT_WEIGHT.BOLD}
                        />
                      )}
                    {/* {r2rButtonText && (
                      <CustomLink
                        ariaLabel={r2rButtonText}
                        taggingInfo={{ ...taggingInfo, componentContent: r2rButtonText }}
                        onClick={onClickR2RHandler}
                        target="_blank"
                      >
                        <TextInfo
                          text={r2rButtonText}
                          kind={TEXT_KIND.SPAN}
                          color={TEXT_COLOR.MOVISTAR_BLUE}
                          size={TEXT_SIZE.CAPTION3}
                          fontType={TEXT_FONT_WEIGHT.REGULAR}
                          decoration={TEXT_DECORATION.UNDERLINE}
                        />
                      </CustomLink>
                    )} */}
                    {showR2RInfo && client.status === API_STATUS.LOADING && (
                      <div className="PreventionModal_content_r2r-info__text--action__spinner">
                        <Spinner operation={LOADING_STATE.LOADING} />
                      </div>
                    )}
                  </div>
                )}
                {r2rList && (
                  <div className="PreventionModal_content_r2r-info__text--list">
                    {r2rList.map(
                      ({ productName: r2rName, cuotaActual, cuotaFutura }) => {
                        return (
                          <div className="PreventionModal_content_r2r-info__text--list___item">
                            <div className="PreventionModal_content_r2r-info__text--list___item---name">
                              <TextInfo
                                text={r2rName}
                                color={TEXT_COLOR.GREY5}
                                size={TEXT_SIZE.CAPTION3}
                                fontType={TEXT_FONT_WEIGHT.BOLD}
                              />
                            </div>
                            <Price
                              fontType={PRICE_FONT_WEIGHT.REGULAR}
                              fontTypeUnity={PRICE_FONT_WEIGHT.REGULAR}
                              size={PRICE_SIZE.XXXS}
                              color={TEXT_COLOR.GREY5}
                              decoration={PRICE_DECORATION.LINE_THROUGH}
                              price={cuotaActual}
                              currency="€"
                            />
                            <Price
                              fontType={PRICE_FONT_WEIGHT.REGULAR}
                              fontTypeUnity={PRICE_FONT_WEIGHT.REGULAR}
                              size={PRICE_SIZE.XXXS}
                              color={TEXT_COLOR.RED_DARK}
                              price={cuotaFutura}
                              currency="€"
                              quote="mes"
                            />
                          </div>
                        );
                      }
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {downgrades && (
          <div className="PreventionModal_content_downgrades">
            {captitalizedDowngradesTitle && (
              <TextInfo
                text={captitalizedDowngradesTitle}
                kind={TEXT_KIND.PARAGRAPH}
                color={TEXT_COLOR.GREY6}
                size={TEXT_SIZE.T4}
                fontType={TEXT_FONT_WEIGHT.BOLD}
              />
            )}
            {downgrades.items &&
              Array.isArray(downgrades.items) &&
              downgrades.items.length > 0 && (
                <div className="PreventionModal_content_downgrades-items">
                  {downgrades.items.map((item) => (
                    <div className="item">
                      <div className="icon">
                        <IconGlyph
                          {...item}
                          width={34}
                          height={34}
                          circleLayout={6}
                          backgroundColor={TEXT_COLOR.WHITE}
                          layoutSize={{
                            width: 46,
                            height: 46,
                          }}
                          className="dashedBorder"
                        />
                      </div>
                      <div className="charac">
                        <TextInfo
                          text={item.text}
                          kind={TEXT_KIND.PARAGRAPH}
                          color={TEXT_COLOR.GREY6}
                          size={TEXT_SIZE.BODY1}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
          </div>
        )}
      </div>
      <div className="PreventionModal_Footer">
        <div className="PreventionModal_Footer-form">
          {submitText && onSubmit && (
            <Form key={activePromo} id="PrevenModalForm">
              <RetenModalForm
                // havePromotion={havePromotion}
                promoUrlLegal={promoUrlLegal}
                onSubmit={onSubmit}
                productName={productName}
                // legalText={legalText}
                // legalLinkText={legalLinkText}
                submitText={submitText}
                dismissText={dismissText}
                componentProduct={componentProduct}
                isChecked
              />
            </Form>
          )}
        </div>
      </div>
      <style jsx>
        {`
          .PreventionModal {
            background-color: ${COLORS.white};
            padding: 1.5rem;
            border-radius: 16px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 1rem;
            width: 70vw;
            max-width: 808px;
            max-height: 80dvh;
            overflow: hidden;
            &_Header {
              display: flex;
              justify-content: space-between;
            }
            &_content {
              display: flex;
              flex-direction: column;
              gap: 1rem;
              flex-grow: 1;
              overflow-y: auto !important;
              scrollbar-width: thin;
              &_r2r {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                &-info {
                  display: flex;
                  gap: 0.5rem;
                  align-items: flex-start;
                  :global(p) {
                    width: 100%;
                  }
                  &__text {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;
                    &--action {
                      display: flex;
                      gap: 1rem;
                      &__spinner {
                        position: relative;
                      }
                    }
                    &--list {
                      display: flex;
                      flex-direction: column;
                      gap: 0.5rem;
                      &___item {
                        display: flex;
                        gap: 0.5rem;
                        align-items: flex-end;
                        &---name {
                          display: -webkit-box;
                          -webkit-box-orient: vertical;
                          -webkit-line-clamp: 1;
                          max-height: 1.5em;
                          overflow: hidden;
                        }
                      }
                    }
                  }
                }
              }
              -ms-overflow-style: none;
              &_advice {
                display: flex;
                gap: 0.5rem;
                align-items: flex-start;
                :global(p) {
                  width: 100%;
                }
                  &_text {
                    display: flex;
                    flex-direction: column;
                  }
              }
              &_downgrades {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                &-items {
                  gap: 1rem;
                  display: flex;
                  flex-direction: column;
                  .item {
                    display: flex;
                    gap: 1rem;
                    align-items: center;
                    :global(.dashedBorder) {
                      border: 1px dashed ${COLORS.grey500};
                    }
                  }
                }
              }
            }
            &_Footer {
              .buttons {
                display: flex;
                gap: 1rem;
              }
            }
          }
          hr {
            width: 100%;
            color: ${COLORS.grey300};
          }
          @media (max-width: 768px) {
            .PreventionModal {
              width: 100vw;
              border-radius: 1rem 1rem 0rem 0rem;
              max-height: 80dvh;
              &_Footer {
                .buttons {
                  flex-direction: column;
                }
              }
            }
          }
        `}
      </style>
    </div>
  );
};

export default PreventionModal;
